import React from 'react';
const GoogleTranslationAttribute = () => {
  return (
    <div className="d-flex justify-content-end">
      <img src="/images/google-translation.png" alt="text attribution" />
    </div>
  );
};
export default GoogleTranslationAttribute;
